import { useQuery } from '@tanstack/react-query';

import { otpauthQRCodeQuery } from '@rootsight/shared';
import { Skeleton } from '@rootsight/ui';

/** OTPQRCode draws an authenticator app's enrollment URI as a QR code. The
 * encoder loads on first use; a block of the same size stands in until then,
 * and if it cannot load, the link and the key beside it still work. */
export function OTPQRCode({ uri, alt }: { uri: string; alt: string }) {
  const qr = useQuery(otpauthQRCodeQuery(uri));
  if (!qr.data) {
    return qr.isError ? null : <Skeleton shape="block" width="12rem" height="12rem" />;
  }
  return <img src={qr.data} alt={alt} width={192} height={192} />;
}
